export default __webpack_public_path__ + "static/media/element_spec_69.420fdc8f.webp";